import { Breakpoints, styled } from "@vw-marketing/us-components";

import { VWTheme } from "../../../typings/vw-theme";

export const StyledGarageVehicleCardContainer = styled.div`
  ${({ theme, hasImage, isSelected }: { theme: VWTheme, hasImage: boolean, isSelected: boolean }) => {
    return `
      align-items: center;
      align-self: stretch;
      background: ${theme.colors.background.primary};
      border-radius: 12px;
      border: ${isSelected ? `2px solid ${theme.colors.border.active}` : `0.5px solid ${theme.colors.border.default}`};
      cursor: pointer;
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static300};
      justify-content: center;
      min-width: 232px;
      padding-bottom: ${hasImage ? theme.size.static300 : theme.size.static250};
      padding-left: ${theme.size.static350};
      padding-right: ${theme.size.static350};
      padding-top: ${theme.size.static250};

      width: 100%;

      @media (min-width: ${Breakpoints.b560}px) {
        min-height: ${hasImage ? '224px' : 'auto'};
        padding-bottom: ${theme.size.static300};
        padding-top: ${theme.size.static300};
      }

      @media (min-width: ${Breakpoints.b1600}px) {
        min-height: ${hasImage ? '243px' : 'auto'};
        padding-bottom: ${hasImage ? theme.size.static350 : theme.size.static300};
      }
    `;
  }}
`;

export const StyledHeaderWrapper = styled.div`
  ${({ theme }: { theme: VWTheme }) => {
    return `
      display: flex;
      gap: ${theme.size.static200};
      justify-content: space-between;
      width: 100%;
    `;
  }}
`;

export const StyledVehicleInformationContainer = styled.div`
  ${({ theme }: { theme: VWTheme }) => {
    return `
      align-items: flex-start;
      align-self: stretch;
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static100};
    `;
  }}
`;

export const StyledImageContainer = styled.div`
  align-items: center;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-height: 95px;
  max-width: 100%;

  img {
    max-width: 316px !important;

    @media (min-width: ${Breakpoints.b560}px) {
      max-width: 340px !important;
    }

    @media (min-width: ${Breakpoints.b1600}px) {
      max-width: 360px !important;
    }
  }
`;

